import * as THREE from 'three';
import { PolygonClipVolume } from './polygon-clip-volume.js';
import { EventDispatcher } from '../event-dispatcher.js';

export class ClippingTool extends EventDispatcher {
  viewer: any;
  maxPolygonVertices: number;
  sceneMarker: THREE.Scene;
  sceneVolume: THREE.Scene;
  scene: any;
  onRemove: (e: any) => void;
  onAdd: (e: any) => void;

  constructor(viewer: any) {
    super();

    this.viewer = viewer;

    this.maxPolygonVertices = 8;

    this.addEventListener('start_inserting_clipping_volume', (_e: any) => {
      this.viewer.dispatchEvent({
        type: 'cancel_insertions',
      });
    });

    this.sceneMarker = new THREE.Scene();
    this.sceneVolume = new THREE.Scene();
    this.sceneVolume.name = 'scene_clip_volume';
    this.viewer.inputHandler.registerInteractiveScene(this.sceneVolume);

    this.onRemove = (e: any) => {
      this.sceneVolume.remove(e.volume);
    };

    this.onAdd = (e: any) => {
      this.sceneVolume.add(e.volume);
    };

    this.viewer.inputHandler.addEventListener('delete', (e: any) => {
      let polyVolumes = e.selection.filter((e: any) => e instanceof PolygonClipVolume);
      polyVolumes.forEach((e: any) => this.viewer.scene.removePolygonClipVolume(e));
    });
  }

  setScene(scene: any): void {
    if (this.scene === scene) {
      return;
    }

    if (this.scene) {
      this.scene.removeEventListeners('clip_volume_added', this.onAdd);
      this.scene.removeEventListeners('clip_volume_removed', this.onRemove);
      this.scene.removeEventListeners('polygon_clip_volume_added', this.onAdd);
      this.scene.removeEventListeners('polygon_clip_volume_removed', this.onRemove);
    }

    this.scene = scene;

    this.scene.addEventListener('clip_volume_added', this.onAdd);
    this.scene.addEventListener('clip_volume_removed', this.onRemove);
    this.scene.addEventListener('polygon_clip_volume_added', this.onAdd);
    this.scene.addEventListener('polygon_clip_volume_removed', this.onRemove);
  }

  update(): void {}
}
